export enum FlinkCoProfileStatus {
	AwaitingPayment = 'AwaitingPayment',
	Active = 'Active',
	Disabled = 'Disabled',
}
